import * as Yup from "yup";

const enderecoValidator = Yup.object().shape({
  exterior: Yup.boolean().required(),
  cep: Yup.string().when("exterior", {
    is: false,
    then: Yup.string()
      .matches(/^[0-9]{8}$/, "CEP inválido")
      .required("CEP"),
    otherwise: Yup.string().nullable(),
  }),
  logradouro: Yup.string().required("Logradouro"),
  numero: Yup.string().required("Número"),
  bairro: Yup.string().required("Bairro"),
  cidadeId: Yup.number().when("exterior", {
    is: false,
    then: Yup.number().required("Cidade"),
    otherwise: Yup.number().nullable(),
  }),
  paisId: Yup.number().when("exterior", {
    is: true,
    then: Yup.number().required("País"),
    otherwise: Yup.number().nullable(),
  }),
  descricao: Yup.string().nullable(),
});

export default enderecoValidator;
